import React, { useState } from "react";
import { Button, Card, Flex, Text } from "@jsq/ds/core";
import {
  ComplianceCaseStatus,
  ComplianceCaseTypeEnum as CaseType,
} from "~/graphql/supergraphEnums";
import { type GetComplianceCaseQuery } from "~/graphql/supergraphTypes";
import CreateEscalationModal from "./CreateEscalationModal";
import { IssueGrid } from "./IssueGrid";
import { ImpactedGPContext } from "./IssueGrid/ImpactedGPGrid/impactedGPcontext";
import { EscalationsHeader_Style, Hidden } from "./styles_vanilla.css";

interface Props {
  complianceCase: GetComplianceCaseQuery["complianceCase"] | undefined;
  assigneeRole?: "maker" | "checker";
}

const Escalations: React.FC<Props> = ({ complianceCase, assigneeRole }) => {
  const escalationCases: boolean = complianceCase?.escalations != null;
  const [isEscalationModalOpen, setIsEscalationModalOpen] = useState<boolean>(false);
  const [gpCount, setGpCount] = useState<number>(0);

  const onCreateEscalation = () => {
    setIsEscalationModalOpen(true);
  };

  const onCloseModal = () => {
    setIsEscalationModalOpen(false);
  };

  return (
    <ImpactedGPContext.Provider value={{ count: gpCount, setCount: setGpCount }}>
      <Card data-testid="current-escalation">
        <Flex
          className={EscalationsHeader_Style}
          flexDirection="row"
          justifyContent="space-between"
        >
          <Text variant="secondary-md">CURRENT ESCALATION</Text>
          {complianceCase?.status == ComplianceCaseStatus.InProgress && (
            <Button
              data-testid="create-escalation-button"
              icon="plus"
              variant={escalationCases ? "neutral" : "primary"}
              onClick={onCreateEscalation}
              disabled={escalationCases || !assigneeRole || assigneeRole === "checker"}
              className={complianceCase.caseType == CaseType.Escalation ? Hidden : undefined}
            >
              Create escalation
            </Button>
          )}
        </Flex>
        {isEscalationModalOpen && (
          <CreateEscalationModal
            show={isEscalationModalOpen}
            onCloseModal={onCloseModal}
            caseType={complianceCase?.caseType ?? undefined}
            profileId={complianceCase?.investingProfile?.id ?? 0}
            caseStatus={complianceCase?.status ?? ComplianceCaseStatus.Ready}
            profilesForCase={complianceCase}
          />
        )}
        {escalationCases && complianceCase?.status != ComplianceCaseStatus.Closed ? (
          <IssueGrid complianceCase={complianceCase} assigneeRole={assigneeRole} />
        ) : (
          <Text variant="regular-md">There is no current escalation</Text>
        )}
      </Card>
      {escalationCases && complianceCase?.status == ComplianceCaseStatus.Closed && (
        <Card data-testid="escalation-history">
          <Text className={EscalationsHeader_Style} variant="secondary-md">
            ESCALATION HISTORY
          </Text>
          <IssueGrid complianceCase={complianceCase} />
        </Card>
      )}
    </ImpactedGPContext.Provider>
  );
};
export default Escalations;
